export var autosuggestTheme = {
    container: {
        position: 'relative'
    },
    suggestionsContainer: {
        borderRadius: '0.25rem',
        boxShadow: '0 3px 14px 0 rgba(0, 0, 0, 0.17)',
        marginTop: '-1rem',
        position: 'absolute',
        width: '100%',
        zIndex: 100,
        backgroundColor: '#ffffff'
    },
    suggestionsContainerOpen: {
        border: "1px solid #dddddd"
    },
    suggestionsList: {
        listStyle: 'none',
        padding: 0,
        margin: '0.25rem 0'
    },
    suggestion: {
        padding: '0 0.75rem',
        fontFamily: 'HK Grotesk Light'
    },
    suggestionHighlighted: {
        backgroundColor: 'rgba(47, 223, 209, 0.2)',
        cursor: 'pointer'
    }
};
//# sourceMappingURL=style.js.map